/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: Xinner
 * @LastEditTime: 2021-02-23 14:11:58
 */
import router from './index';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { Route } from 'vue-router';
import UserModule from '@/store/modules/user';
import axios from 'axios';
// import SessionModule from '@/store/modules/session';

// 白名单，未登录用户可以访问
const whiteList = ['/', '/login', '/logout', '/register', '/setpass', '/news', /\/portal\//i];
function whiteListTest(path: string) {
  return whiteList.some(o => {
    if (o instanceof RegExp) {
      return o.test(path);
    } else {
      return o === path;
    }
  });
}
NProgress.configure({ showSpinner: false }); // NProgress Configuration

/** 全局路由守卫，处理动态权限 */
router.beforeEach((to: Route, from: Route, next: any) => {
  NProgress.start();
  if (UserModule.getToken) {
    if (UserModule.userId.length <= 0) {
      console.log('获取用户信息');
      // UserModule.GetInfo()
      //   .then(() => {
      //     next({ ...to, replace: true });
      //   })
      //   .catch(err => {
      //     UserModule.FedLogOut().then(() => {
      //       next({ path: '/' });
      //     });
      //   });
    } else {
      next();
    }
  } else {
    if (whiteListTest(to.path)) {
      next();
    } else {
      //next(`/login`);
      next(`/login?redirect=${to.path}`);
    }
  }
});

router.afterEach(() => {
  NProgress.done();
  // console.log('router.afterEach', router)
});
